import React from "react";
import { Seo, Section, SectionHead, FadeUp } from "./Ui";
import { TECHNOLOGY } from "./data";

export default function DrezoroTechnology() {
  return (
    <div data-testid="drezoro-technology">
      <Seo title="Technology — DREZORO" description="DREZORO builds advanced business technology: artificial intelligence, automation, marketing technology, data intelligence, cloud software, and AI assistants." />
      <Section>
        <SectionHead label="Our Technology" title="One intelligent foundation. Every company benefits."
          intro="DREZORO engineers its core technology in-house and deploys it across the group — so every brand operates with capabilities usually reserved for the largest enterprises." />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {TECHNOLOGY.map((t, i) => (
            <FadeUp key={t.t} delay={i * 0.05}>
              <div className="dz-card p-7 h-full" data-testid={`dz-techpage-${i}`}>
                <div className="w-8 h-px bg-blue-500 mb-5" aria-hidden="true" />
                <h3 className="text-base font-medium text-white">{t.t}</h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{t.d}</p>
              </div>
            </FadeUp>
          ))}
        </div>
        <FadeUp className="mt-12">
          <div className="dz-card p-8 md:p-10 grid md:grid-cols-3 gap-8">
            {[
              ["Built for scale", "Multi-tenant cloud architecture with strict data isolation between every business and workspace."],
              ["Human-approved automation", "AI drafts, plans, and executes — humans stay in command through audited approval workflows."],
              ["Verified outcomes", "Publishing, campaigns, and automations are verified end-to-end, never assumed."],
            ].map(([t, d]) => (
              <div key={t}>
                <h3 className="text-sm font-semibold text-blue-400 uppercase tracking-wider">{t}</h3>
                <p className="mt-2.5 text-sm text-zinc-400 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </FadeUp>
      </Section>
    </div>
  );
}
